import React, { Component } from "react";
import styled from "styled-components";

/*
WHATS GOING ON HERE?

React's 'dangerouslySetInnerHTML' won't execute script tags.
So here we've hacked together a way to execute this script tag
on the global window AFTER the component is mounted.

The Regex is necessary because we don't want React to 'know' that this
is a script tag.

The script tag is 'built' after the component mounts.
 */
let x =
  "<a href='https://www.iubenda.com/privacy-policy/7788348' class='iubenda-white no-brand iub-body-embed iubenda-embed' title='Privacy Policy'>Privacy Policy</a><scr" +
  "ipt>(function (w,d) {var loader = function () {var s = d.createElement('script'), tag = d.getElementsByTagName('script')[0]; s.src = 'https://cdn.iubenda.com/iubenda.js'; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener('load', loader, false);}else if(w.attachEvent){w.attachEvent('onload', loader);}else{w.onload = loader;}})(window, document);</scr" +
  "ipt>";

const extractscript = /<script>(.+)<\/script>/gi.exec(x);
x = x.replace(extractscript[0], "");

class GettingStartedPage extends Component {
  componentDidMount() {
    window.eval(extractscript[1]);
  }

  render() {
    return (
      <GettingStartedPageContainer>
        <h1>App User Privacy Agreement</h1>
        <div dangerouslySetInnerHTML={{ __html: x }} />
      </GettingStartedPageContainer>
    );
  }
}

const GettingStartedPageContainer = styled.div`
  margin: 100px 0;

  @media screen and (max-width: 768px) {
    margin: 50px 0 50px;
  }

  h1 {
    margin: 50px auto;
    text-align: center;
  }
`;

export default GettingStartedPage;



// WEBPACK FOOTER //
// ./src/pages/privacy.jsx